export default __webpack_public_path__ + "static/logo-1169c8cca0bb950edaf96ac10bc62a62.png";